// ----------------------------------------------------------------------------
// Component: Collection List
// ----------------------------------------------------------------------------
//
// A list of collections
//
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/swiper-controls/swiper-control';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_collection-list.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--collection-list';
var CAROUSEL_CLASS = 'carousel--collection-list';
var CAROUSEL_SECTION_SELECTOR = '.collection-list';
var CAROUSEL_SECTION_CLASS = 'collection-list';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';

// -------------------------------------
// Helpers
// -------------------------------------
function initCollectionListCarousel(element, index) {
  var _element$querySelecto, _element$querySelecto2;
  var carouselEl = element.querySelector(CAROUSEL_SELECTOR);
  if (!carouselEl) return null;
  carouselEl.classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));
  (_element$querySelecto = element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR)) === null || _element$querySelecto === void 0 || _element$querySelecto.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index));
  (_element$querySelecto2 = element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR)) === null || _element$querySelecto2 === void 0 || _element$querySelecto2.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
    slidesPerView: 2,
    spaceBetween: 8,
    observer: true,
    observeParents: true,
    a11y: false,
    watchOverflow: true,
    allowTouchMove: true,
    simulateTouch: true,
    grabCursor: true,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: true,
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 12
      }
    },
    navigation: {
      nextEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index),
      prevEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index)
    }
  });
  swiper.slides.forEach((slide, slideIndex) => {
    var slideLink = slide.querySelector('a');
    slideLink === null || slideLink === void 0 || slideLink.addEventListener('focus', () => {
      swiper.slideTo(slideIndex);
    });
  });
  return swiper;
}

// -------------------------------------
// Hooks
// -------------------------------------
var collectionListInstances = new Map();
function mountCollectionListSections() {
  collectionListInstances.forEach(swiper => swiper.destroy());
  collectionListInstances.clear();
  document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
    var swiper = initCollectionListCarousel(element, index);
    if (swiper) collectionListInstances.set(element, swiper);
  });
}
mountCollectionListSections();
document.addEventListener('shopify:section:load', event => {
  var isCollectionList = event.target.matches(CAROUSEL_SECTION_SELECTOR) || event.target.matches('.section--collection-list') || event.target.querySelector(CAROUSEL_SELECTOR);
  if (isCollectionList) {
    mountCollectionListSections();
  }
});